import { z } from 'zod';

export const $CandidateCurrency = z.object({
  id: z.number(),
  code: z.string(),
  name: z.string(),
  value: z.string(),
});
